// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3B7Rk","colMin":"styles_colMin__1VZ2p","colCheckbox":"styles_colCheckbox__yToq2"};